import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";

import FormOne from "./FormOne";
import FieldName from "./FieldName";
import { PageHeader, Paper } from "../../../components";
import { CancelButton } from "../../css components/Button";

export default function FormDisplay({
  brands,
  editState,
  formikProps,
  setEditState,
  changeData,
  setChangeData,
  fields,
  additionalFields,
  PlatformTenantList,
}) {
  const navigate = useNavigate();
  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <PageHeader
          pageName={"Onboarded Brand Details"}
          pageHeader={formikProps.values.brandDetails?.brand_name}
          buttons={[
            <CancelButton variant="outlined" onClick={() => navigate(-1)}>
              Back
            </CancelButton>,
          ]}
        />
      </Grid>

      <Grid size={12}>
        <Paper gridSpacing={6}>
          <FormOne
            PlatformTenantList={PlatformTenantList}
            additionalFields={additionalFields}
            fields={fields}
            formikProps={formikProps}
            brands={brands}
            editState={editState}
            setEditState={setEditState}
            changeData={changeData}
            setChangeData={setChangeData}
          />

          {formikProps.values.connection && (
            <FieldName formikProps={formikProps} />
          )}
        </Paper>
      </Grid>
    </Grid>
  );
}
